import $axios from "../../api";

const state = () => ({
  promotions: [],
  loading: false,
  errors: null,
  page: 1,
  promotionDetail: null,

  categories: [],
  categoriesLoading: false,
});

const mutations = {
  ASSIGN_PROMOTIONS(state, payload) {
    state.promotions = payload;
  },
  SET_LOADING(state, payload) {
    state.loading = payload;
  },
  ASSIGN_ERRORS(state, payload) {
    state.errors = payload;
  },
  ASSIGN_CATEGORIES(state, payload) {
    state.categories = payload;
  },
  SET_CATEGORIES_LOADING(state, payload) {
    state.categoriesLoading = payload;
  },
  SET_PAGE(state, payload) {
    state.page = payload;
  },
  ASSIGN_PROMOTION_DETAIL(state, payload) {
    state.promotionDetail = payload;
  },
};

const actions = {
  fetchCategories({ commit }) {
    commit("SET_CATEGORIES_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get("/website/article-promotion/category-list")
        .then((response) => {
          commit("ASSIGN_CATEGORIES", response.data.data);
          resolve();
        })
        .catch((error) => {
          commit("ASSIGN_ERRORS", error);

          dispatch('Main/globalSweetAlert', error.response, {
            root: true,
          });

          reject(error);
        })
        .finally(() => {
          commit("SET_CATEGORIES_LOADING", false);
        });
    });
  },
  fetchList({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get("/website/article-promotion/list", {
          params: {
            page: state.page,
            view: rootState.Main.view,
            ...payload,
          },
        })
        .then((response) => {
          commit("ASSIGN_PROMOTIONS", response.data.data);
          resolve();
        })
        .catch((error) => {
          commit("ASSIGN_ERRORS", error);
          dispatch('Main/globalSweetAlert', error.response, {
            root: true,
          });

          reject(error);
        })
        .finally(() => {
          commit("SET_LOADING", false);
        });
    });
  },
  getDetail({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);
    commit("ASSIGN_ERRORS", null);

    return new Promise((resolve, reject) => {
      $axios
        .get("/website/article-promotion/view", {
          params: payload,
        })
        .then((response) => {
          commit("ASSIGN_PROMOTION_DETAIL", response.data.data);
          resolve();
        })
        .catch((error) => {
          if (error.response && error.response.status === 422) {
            commit("ASSIGN_ERRORS", error.response.data.errors);
          }
          dispatch('Main/globalSweetAlert', error.response, {
            root: true,
          });

          reject(error);
        })
        .finally(() => {
          commit("SET_LOADING", false);
        });
    });
  },
  create({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);
    commit("ASSIGN_ERRORS", null);

    return new Promise((resolve, reject) => {
      $axios
        .post("/website/article-promotion/create", payload)
        .then(() => {
          resolve();
        })
        .catch((error) => {
          if (error.response && error.response.status === 422) {
            commit("ASSIGN_ERRORS", error.response.data.errors);
          }
          dispatch('Main/globalSweetAlert', error.response, {
            root: true,
          });

          reject(error);
        })
        .finally(() => {
          commit("SET_LOADING", false);
        });
    });
  },
  update({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);
    commit("ASSIGN_ERRORS", null);

    return new Promise((resolve, reject) => {
      $axios
        .put("/website/article-promotion/update", payload)
        .then(() => {
          resolve();
        })
        .catch((error) => {
          if (error.response && error.response.status === 422) {
            commit("ASSIGN_ERRORS", error.response.data.errors);
          }
          dispatch('Main/globalSweetAlert', error.response, {
            root: true,
          });

          reject(error);
        })
        .finally(() => {
          commit("SET_LOADING", false);
        });
    });
  },
  showhide({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);
    commit("ASSIGN_ERRORS", null);

    return new Promise((resolve, reject) => {
      $axios
        .put("/website/article-promotion/showhide", payload)
        .then(() => {
          resolve();
        })
        .catch((error) => {
          if (error.response && error.response.status === 422) {
            commit("ASSIGN_ERRORS", error.response.data.errors);
          }
          dispatch('Main/globalSweetAlert', error.response, {
            root: true,
          });

          reject(error);
        })
        .finally(() => {
          commit("SET_LOADING", false);
        });
    });
  },
  publish({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);
    commit("ASSIGN_ERRORS", null);

    return new Promise((resolve, reject) => {
      $axios
        .put("/website/article-promotion/publish", payload)
        .then(() => {
          resolve();
        })
        .catch((error) => {
          if (error.response && error.response.status === 422) {
            commit("ASSIGN_ERRORS", error.response.data.errors);
          }
          dispatch('Main/globalSweetAlert', error.response, {
            root: true,
          });

          reject(error);
        })
        .finally(() => {
          commit("SET_LOADING", false);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};